module.exports = __webpack_public_path__ + "static/media/S1.3367271a.png";